'use client';

import { Spinner } from '@lectura/ui';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState, type ReactNode } from 'react';
import { useAuth } from '@/lib/auth';

/**
 * Kliens-oldali guard: ha nincs érvényes access token, /login-ra redirektel
 * a `?next=` paraméterrel. A login page maga nem kerül guard alá.
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (!hydrated) return;
    const auth = useAuth.getState();
    if (pathname?.startsWith('/login')) return;
    if (!auth.isAuthenticated()) {
      // próbáljunk refreshelni: ha a refresh-token még él, elkerüljük a teljes loginflow-t
      void auth.refresh().then((ok) => {
        if (!ok) {
          const next = encodeURIComponent(pathname ?? '/');
          router.replace(`/login?next=${next}`);
        }
      });
    }
  }, [hydrated, pathname, router]);

  if (!hydrated) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-8" />
      </div>
    );
  }
  return <>{children}</>;
}
